module.exports = __webpack_public_path__ + "img/login_font.8b5e2e99.png";